import { LIVE_MODULE_IDS } from '../config/liveModules';

function parseList(raw) {
  return String(raw || '')
    .split(/[,;]/)
    .map((s) => s.trim())
    .filter(Boolean);
}

/**
 * @param {string[]} allModuleIds
 * @returns {string[]}
 */
export function getLiveModuleIds(allModuleIds = []) {
  const fromEnv = parseList(process.env.REACT_APP_LIVE_MODULES);
  if (fromEnv.length > 0) return fromEnv;
  if (process.env.NODE_ENV !== 'production') return allModuleIds;
  return LIVE_MODULE_IDS;
}

/**
 * @param {string} moduleId
 * @param {string[]} allModuleIds
 * @returns {boolean}
 */
export function isModuleLive(moduleId, allModuleIds = []) {
  return getLiveModuleIds(allModuleIds).includes(moduleId);
}

const DEFAULT_RELEASE_LABEL = 'Coming soon';

/**
 * Applies production release gating to a catalog entry.
 * Modules already marked `comingSoon` in the catalog are left unchanged.
 *
 * @param {Record<string, unknown>} module
 * @param {string[]} allModuleIds
 * @returns {Record<string, unknown>}
 */
export function applyModuleReleaseConfig(module, allModuleIds) {
  if (module.comingSoon) return module;
  if (isModuleLive(module.id, allModuleIds)) return module;
  return {
    ...module,
    comingSoon: true,
    releaseLabel: module.releaseLabel || DEFAULT_RELEASE_LABEL,
  };
}
